export function isDev() {
  try {
    return process && process.env && process.env.NODE_ENV !== 'production';
  } catch (e) {
    return true;
  }
}
